import { Row } from "@stenajs-webui/core";
import { TimeTag } from "@stenajs-webui/elements";
import type { FC } from "react";

interface TimeGapProps {
  time: string;
}

export const TimeGap: FC<TimeGapProps> = ({ time }) => {
  return (
    <Row justifyContent={"center"}>
      <TimeTag label={time} />
    </Row>
  );
};
